import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  signInWithEmailAndPassword, 
  signOut,
  onAuthStateChanged,
  setPersistence,
  browserSessionPersistence
} from "firebase/auth";

// Twoja konfiguracja Firebase - wklej z konsoli Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Ustawienie trwałości sesji (sesja trwa do zamknięcia przeglądarki)
setPersistence(auth, browserSessionPersistence);

// Funkcja logowania
export const loginUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    // Pobierz token JWT do komunikacji z backendem
    const token = await userCredential.user.getIdToken();
    
    return { 
      success: true, 
      user: userCredential.user,
      token: token
    };
  } catch (error) {
    let message = "Błąd logowania";
    switch (error.code) {
      case 'auth/invalid-email':
        message = "Nieprawidłowy format email";
        break;
      case 'auth/user-disabled':
        message = "Konto zostało zablokowane";
        break;
      case 'auth/user-not-found':
        message = "Nie znaleziono użytkownika";
        break;
      case 'auth/wrong-password':
        message = "Nieprawidłowe hasło";
        break;
      case 'auth/too-many-requests':
        message = "Zbyt wiele nieudanych prób. Spróbuj później";
        break;
      default:
        message = "Wystąpił błąd podczas logowania";
    }
    return { success: false, error: message };
  }
};

// Funkcja wylogowania
export const logoutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

// Funkcja sprawdzająca czy użytkownik jest adminem (na podstawie emaila)
export const isUserAdmin = (user) => {
  if (!user) return false;
  
  // Lista dozwolonych emaili administratorów
  const adminEmails = [
    'monika.joanna.baszczyk@gmail.com',
    'placeo@wp.pl'
  ];
  
  return adminEmails.includes(user.email);
};

// Funkcja nasłuchująca zmian stanu autoryzacji
export const onAuthChange = (callback) => {
  return onAuthStateChanged(auth, callback);
};